import { rankingData } from '@/mocks/home';

const trendIcon = (trend: string) => {
  if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500 w-3 h-3 flex items-center justify-center"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-accent-600 w-3 h-3 flex items-center justify-center"></i>;
  return <i className="ri-subtract-line text-foreground-400 w-3 h-3 flex items-center justify-center"></i>;
};

const rankColor = (rank: number) => {
  if (rank === 1) return 'bg-accent-500 text-white';
  if (rank === 2) return 'bg-accent-400 text-white';
  if (rank === 3) return 'bg-accent-300 text-accent-900';
  return 'bg-foreground-100 text-foreground-600';
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          高分排行
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          综合评分与热度统计，发现最受影迷推崇的经典之作
        </p>
        <div className="space-y-2">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-3 md:gap-4 bg-background-50 border border-background-200/60 rounded-lg p-3 md:p-4 hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${rankColor(item.rank)}`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-foreground-900">{item.title}</span>
              </div>
              <span className="flex-shrink-0 text-xs px-2 py-1 rounded bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                {item.tag}
              </span>
              <span className="flex-shrink-0 text-sm font-bold text-accent-600 whitespace-nowrap">{item.score}</span>
              <span className="flex-shrink-0 w-4 h-4 flex items-center justify-center">
                {trendIcon(item.trend)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}